"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rg_rj = exports.rg_sp = void 0;
function rg_sp(number) {
    // if(number.length>8){alert("Erro. Não existe RG SP\ncom mais de 8 dígitos.");}
    number = "0000000" + number;
    number = number.slice(number.length - 8);
    var b1 = parseInt(number.slice(7));
    var b2 = parseInt(number.slice(6, 7));
    var b3 = parseInt(number.slice(5, 6));
    var b4 = parseInt(number.slice(4, 5));
    var b5 = parseInt(number.slice(3, 4));
    var b6 = parseInt(number.slice(2, 3));
    var b7 = parseInt(number.slice(1, 2));
    var b8 = parseInt(number.slice(0, 1));
    var cispDig = (b1 * 2 + b2 * 3 + b3 * 4 + b4 * 5 + b5 * 6 + b6 * 7 + b7 * 8 + b8 * 9) % 11;
    if (cispDig == 10) {
        cispDig = "X";
    }
    var cispDV = cispDig;
}
exports.rg_sp = rg_sp;
function rg_rj(number) {
    // if(number.length>8){alert("Erro. Não existe RG-RJ/MaSP-MG\ncom mais de 8 dígitos.");}
    number = "0000000" + number;
    number = number.slice(number.length - 8);
    var b1 = parseInt(number.slice(7));
    var b2 = parseInt(number.slice(6, 7));
    var b3 = parseInt(number.slice(5, 6));
    var b4 = parseInt(number.slice(4, 5));
    var b5 = parseInt(number.slice(3, 4));
    var b6 = parseInt(number.slice(2, 3));
    var b7 = parseInt(number.slice(1, 2));
    var b8 = parseInt(number.slice(0, 1));
    var ci7 = b1 * 2;
    if (ci7 > 9) {
        ci7 = ci7 - 9;
    }
    var ci56 = b3 * 2;
    if (ci56 > 9) {
        ci56 = ci56 - 9;
    }
    var ci34 = b5 * 2;
    if (ci34 > 9) {
        ci34 = ci34 - 9;
    }
    var ci12 = b7 * 2;
    if (ci12 > 9) {
        ci12 = ci12 - 9;
    }
    var ci67 = b2;
    var ci45 = b4;
    var ci23 = b6;
    var ci01 = b8;
    var cirjDig = (ci7 + ci56 + ci34 + ci12 + ci67 + ci45 + ci23 + ci01) % 10;
    cirjDig = 10 - cirjDig;
    if (cirjDig == 10) {
        cirjDig = 0;
    }
    return cirjDig;
}
exports.rg_rj = rg_rj;
var RG = {
    sp: rg_sp,
    rj: rg_rj
};
exports.default = RG;
//# sourceMappingURL=rg.js.map